/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScenarioStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    ARCHIVED = 'ARCHIVED'
}


export function instanceOfInternalApiScenarioStatus(value: any): boolean {
    for (const key in InternalApiScenarioStatus) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScenarioStatus, key)) {
            if (InternalApiScenarioStatus[key as keyof typeof InternalApiScenarioStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScenarioStatusFromJSON(json: any): InternalApiScenarioStatus {
    return InternalApiScenarioStatusFromJSONTyped(json, false);
}

export function InternalApiScenarioStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioStatus {
    return json as InternalApiScenarioStatus;
}

export function InternalApiScenarioStatusToJSON(value?: InternalApiScenarioStatus | null): any {
    return value as any;
}

export function InternalApiScenarioStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScenarioStatus {
    return value as InternalApiScenarioStatus;
}

